import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="timezone-select"
export default class extends Controller {
  connect() {
    if (this.getValue() === "") {
      this.setUserLocalTimezone();
    }
  }

  getValue() {
    return this.element.options[this.element.selectedIndex].value;
  }

  setUserLocalTimezone() {
    const localTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    for (const option of this.element.options) {
      if (option.value === localTimezone) {
        option.selected = true;
        break;
      }
    }
  }
}
